import Ease from '../_utils/Ease';
import GetOffset from '../_utils/GetOffset';
import GetStyleTransformPrefix from '../_utils/GetStyleTransformPrefix';

const MOBILE_WIDTH = 767; // our mobile-only media query width defined in _variables.scss

export default class Timeline {


	// Constructor
	constructor(element) {

		this.element = element;
		this.content = this.element.querySelector('.timeline--content');
		this.pageCount = parseFloat(this.element.getAttribute('data-pages'));
		this.pageCountMobile = parseFloat(this.element.getAttribute('data-pages-mobile'));
		this.progressText = this.element.querySelector('.timeline--progress strong');
		this.progressTrack = this.element.querySelector('.timeline--progress i');
		this.slider = this.element.querySelector('.timeline--slider');

		this.posCurrent = -1;
		this.posTarget = 0;
		this.posValue = 0;

		this.scrollMin = -1;
		this.scrollMax = -1;
		this.scrollPlay = -1;

		this.animated = {};
		this.updateAnimated = function(){};
		if (this.element.classList.contains('section-timeline-about')) {
			this.updateAnimated = this.animateAbout;
			this.animated.page2 = this.element.querySelector('.page-2');
			this.animated.page3 = this.element.querySelector('.page-3');
			this.animated.page4 = this.element.querySelector('.page-4');
			this.animated.page5 = this.element.querySelector('.page-5');
			this.animated.page6 = this.element.querySelector('.page-6');
			this.animated.page7 = this.element.querySelector('.page-7');
      this.animated.page8 = this.element.querySelector('.page-8');
		} else if (this.element.classList.contains('section-timeline-strategy')) {
			this.updateAnimated = this.animateStrategy;
			this.animated.page2 = this.element.querySelector('.page-2');
			this.animated.page3 = this.element.querySelector('.page-3');
			this.animated.page4 = this.element.querySelector('.page-4');
			this.animated.page5 = this.element.querySelector('.page-5');
		}

		this.transform = GetStyleTransformPrefix();
	}


	// Public Methods
	animate() {
		this.posValue = Ease.lerp(this.posValue, this.posTarget, 0.5);
		if (Math.abs(this.posValue - this.posTarget) < Number.EPSILON) {
			this.posValue = this.posTarget;
		}
		if (this.posCurrent !== this.posValue) {
			const percent = this.posValue * 100;
			const pageCount = (window.innerWidth <= MOBILE_WIDTH) ? this.pageCountMobile : this.pageCount;
			this.progressText.innerHTML = Math.round(percent) + '%';
			this.progressTrack.style.width = percent + '%';


			const sliderOffset = 5; // how much we scroll before the slider starts moving
			var sliderPercent = 0;
			if (percent > sliderOffset) {
				sliderPercent = ((percent - sliderOffset) / (100 - sliderOffset)) * 100;
			}

			this.slider.style[this.transform] = 'translate3d(-' + (sliderPercent * (pageCount - 1)) + 'vw, 0, 0)';
			this.updateAnimated(this.posValue, pageCount);
		}
		this.posCurrent = this.posValue;
	}
	resize() {
		const elementTop = GetOffset.top(this.element);
		const elementHeight = this.element.offsetHeight;
		const windowHeight = window.innerHeight;

		const elementAppear = elementTop - windowHeight;
		const elementDisappear = elementTop + elementHeight;

		this.scrollMin = elementAppear + windowHeight;
		this.scrollMax = elementDisappear - windowHeight;
		this.scrollPlay = elementAppear + (windowHeight * 0.5);
	}
	scroll() {

		// NOTE: we need to recalculate our size values on every scroll update in order
		// to get a less jumpy transition when the .timeline--content element changes
		// from position:fixed to position:absolute.
		this.resize();

		if (this.scrollMax !== -1 && this.scrollMin !== -1) {
			const scrollY = window.pageYOffset;
			if (scrollY >= this.scrollPlay) {
				this.element.classList.add('play');
			}
			if (scrollY < this.scrollMin) {
				this.posTarget = 0;
				this.content.classList.remove('is-bottom');
				this.content.classList.remove('is-fixed');
				this.content.classList.add('is-top');
			} else if (scrollY >= this.scrollMax) {
				this.posTarget = 1;
				this.content.classList.add('is-bottom');
				this.content.classList.remove('is-fixed');
				this.content.classList.remove('is-top');
			} else {
				this.posTarget = (scrollY - this.scrollMin) / (this.scrollMax - this.scrollMin);
				this.content.classList.remove('is-bottom');
				this.content.classList.add('is-fixed');
				this.content.classList.remove('is-top');
			}
		}
	}

	// Animations
	animateAbout(percent, pageCount) {
		const step = 1 / (pageCount + 1);
		if (percent >= step) {
			this.animated.page2.classList.add('play');
		}
		if (percent >= step * 2) {
			this.animated.page3.classList.add('play');
		}
		if (percent >= step * 3) {
			this.animated.page4.classList.add('play');
		}
		if (percent >= step * 4) {
			this.animated.page5.classList.add('play');
		}
		if (percent >= step * 5) {
			this.animated.page6.classList.add('play');
		}
		if (percent >= step * 6) {
			this.animated.page7.classList.add('play');
		}
    if (percent >= step * 7) {
			this.animated.page8.classList.add('play');
		}
	}
	animateStrategy(percent, pageCount) {
		const step = 1 / pageCount;
		if (percent >= step * 0.8) {
			this.animated.page2.classList.add('play');
		}
		if (percent >= step * 2) {
			this.animated.page3.classList.add('play');
		}
		if (percent >= step * 3) {
			this.animated.page4.classList.add('play');
		}
		if (percent >= step * 4) {
			this.animated.page5.classList.add('play');
		}
	}


}
